// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronLeft: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M16.308 21.308 7 12l9.308-9.308 1.063 1.064L9.127 12l8.244 8.244-1.063 1.064Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronLeftOffset: IconOffset = {
    vertical: 10, // Store Custom Code
    horizontal: 28, // Store Custom Code
};

export default React.memo(ChevronLeft);
